import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, Form, Input, MessagePlugin, Select, Textarea } from 'tdesign-react';
import formRulePattern from '@/utils/formRulePattern';
import { createEnv, updateEnv } from '@/services/resourceService';
import Tip from '@/components/Tip';
import { toTsOptions } from '@/utils/common';

const { FormItem } = Form;

function FormModal({ visible, handleClose, detail, proxyOptions, libOptions }) {
  const isEdit = !isEmpty(detail);
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.reset();
    }
    if (!isEmpty(detail)) {
      setTimeout(
        () => form.setFieldsValue({ ...detail, key: detail.envKey, name: detail.envName }),
        50,
      );
    }
  }, [detail, form, visible]);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      try {
        setSubmitting(true);

        if (isEdit) {
          await updateEnv({
            ...fields,
            envId: detail.envId,
          });
        } else {
          await createEnv(fields);
        }
        MessagePlugin.success('操作成功');
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };
  return (
    <Dialog
      visible={visible}
      onClose={() => handleClose()}
      header={isEdit ? '修改环境' : '新建环境'}
      confirmBtn={{
        loading: submitting,
        content: '确认',
      }}
      onConfirm={() => form.submit()}
    >
      <Form
        form={form}
        resetType='initial'
        onSubmit={handleSubmit}
        labelWidth={110}
        style={{ width: '86%' }}
      >
        <FormItem
          name='name'
          label={
            <Tip align='right' content='用于页面显示的环境名称'>
              环境名称
            </Tip>
          }
          rules={[{ required: true, message: '环境名称必填' }]}
        >
          <Input />
        </FormItem>
        <FormItem
          name='key'
          label={
            <Tip align='right' content='用于系统使用环境名称，英文字母+下划线组成'>
              唯一标识符
            </Tip>
          }
          rules={[{ required: true, message: '唯一标识符必填' }, formRulePattern('name')]}
        >
          <Input />
        </FormItem>
        <FormItem
          name='proxyId'
          label={
            <Tip align='right' content='选择环境关联的代理，没有可新建'>
              关联代理
            </Tip>
          }
          rules={[{ required: true, message: '关联代理必填' }]}
        >
          <Select options={toTsOptions(proxyOptions)} />
        </FormItem>
        <FormItem
          name='productLibId'
          label={
            <Tip align='right' content='选择环境关联的制品库，没有可新建'>
              关联制品库
            </Tip>
          }
          rules={[{ required: true, message: '关联制品库必填' }]}
        >
          <Select options={toTsOptions(libOptions)} />
        </FormItem>

        <FormItem name='note' label='环境备注' rules={[{ required: true }]}>
          <Textarea placeholder='填写备注信息' />
        </FormItem>
      </Form>
    </Dialog>
  );
}

export default connect((state) => ({
  proxyOptions: state.resource.proxyOptions,
  libOptions: state.resource.libOptions,
}))(FormModal);
